"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Motive = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const lifecycle_1 = require("@/common/lifecycle");
const canvas_1 = require("@/ui/canvas/canvas");
const panel_1 = require("@/ui/panel/panel");
const settings_1 = require("@/common/settings");
const i18n_1 = require("@/common/i18n");
const icon_light_png_1 = __importDefault(require("@/assets/icons/icon-light.png"));
const icon_dark_png_1 = __importDefault(require("@/assets/icons/icon-dark.png"));
const render_1 = require("./render/render");
class Motive extends lifecycle_1.Disposable {
    constructor(_root) {
        super();
        this._root = _root;
        this._selectedObjectId = "ball"; // default
        this._init();
        this._initListeners();
    }
    _init() {
        // Init metadata
        document.title = (0, i18n_1.$)("app.name");
        document.querySelector("html").lang = (0, i18n_1.getLang)();
        document.head.appendChild((0, jsx_runtime_1.jsx)("link", { rel: "icon", href: icon_light_png_1.default, media: "(prefers-color-scheme: light)", type: "image/png" }));
        document.head.appendChild((0, jsx_runtime_1.jsx)("link", { rel: "icon", href: icon_dark_png_1.default, media: "(prefers-color-scheme: dark)", type: "image/png" }));
        this._canvas = new canvas_1.Canvas(this._root);
        this._render = new render_1.Render(this._canvas);
        this._panel = new panel_1.Panel(this._root);
        // Layout
        if (settings_1.Settings.get().getValue("layout") === "top")
            this._root.classList.add("layout-reverse");
        // Register object switchers
        this._panel.addObjectSwitcher("ball", (0, i18n_1.$)("obj.ball"), lucide_1.Circle, false, true);
        this._panel.addObjectSwitcher("block", (0, i18n_1.$)("obj.block"), lucide_1.Box);
        this._panel.addObjectSwitcher("board", (0, i18n_1.$)("obj.board"), lucide_1.Cuboid, true);
        this._panel.addObjectSwitcher("slope", (0, i18n_1.$)("obj.slope"), lucide_1.TriangleRight, true);
        this._panel.addObjectSwitcher("rope", (0, i18n_1.$)("obj.rope"), lucide_1.Spline, true);
        this._panel.addObjectSwitcher("pole", (0, i18n_1.$)("obj.pole"), lucide_1.Slash, true);
        this._panel.addObjectSwitcher("spring", (0, i18n_1.$)("obj.spring"), lucide_1.Shell, true);
        this._panel.addObjectSwitcher("arc", (0, i18n_1.$)("obj.arc"), lucide_1.Radius, true);
        this._panel.addObjectSwitcher("fixed", (0, i18n_1.$)("obj.fixed"), lucide_1.Grid2X2, true);
        // Initialize the control panel
        this._panel.linkRenderer(this._render);
        this._register(this._canvas);
        this._register(this._render);
        this._register(this._panel);
    }
    _initListeners() {
        this._register(this._panel.onSelectedObjectChange((id) => {
            this._selectedObjectId = id;
        }));
        this._register(this._canvas.onClick((e) => {
            if (this._render.isMouseMode)
                return;
            const obj = this._render.addObject(this._selectedObjectId, e.screenX, e.screenY);
            obj.setName("m");
        }));
        this._register(this._canvas.onRefresh(() => {
            if (!this._render.isPaused)
                this._render.refresh();
        }));
        this._register(settings_1.Settings.get().onDidChange(({ key, value }) => {
            if (key === "layout") {
                value === "top"
                    ? this._root.classList.add("layout-reverse")
                    : this._root.classList.remove("layout-reverse");
            }
        }));
    }
}
exports.Motive = Motive;
